export default __webpack_public_path__ + "685a09f1767de2af43008a8fe44797bd.png";